(function () {

    'use strict';

    angular.module('iplusjs.utils.binary', [
        'lodash',
        'modernizr',
        'iplusjs.utils.device'
    ])
    .service('BinaryUtilsService', BinaryUtilsService);

    BinaryUtilsService.$inject = [
        '$window',
        '$q',
        'lodash',
        'modernizr',
        'DeviceUtilsService'
    ];
    function BinaryUtilsService($window, $q, _, modernizr, DeviceUtilsService) {
        var that = this,
            mimeTypes = {
                pdf: 'application/pdf',
                jpg: 'image/jpeg',
                jpeg: 'image/jpeg',
                tif: 'image/tiff',
                tiff: 'image/tiff',
                png: 'image/png',
                svg: 'image/svg+xml'
            };

        that.convertBinaryToFile = convertBinaryToFile;
        that.getMimeType = getMimeType;
        that.checkMimeType = checkMimeType;
        that.getFileExtension = getFileExtension;
        that.toObjectUrl = toObjectUrl;
        that.convertArrayBufferToJson = convertArrayBufferToJson;
        function convertBinaryToFile(binary, type) {
            return $q(function (resolve) {
                var contentType = mimeTypes[type] || type,
                    file,
                    reader;

                if (!contentType || !modernizr.blobconstructor || !modernizr.bloburls || !modernizr.typedarrays) {
                    return resolve({
                        blobUrl: null,
                        blob: null
                    });
                }

                file = new $window.Blob([binary], {
                    type: contentType
                });
                if (modernizr.filereader && DeviceUtilsService.isIosWebview()) {
                    reader = new FileReader();

                    reader.onload = function () {
                        reader.result;

                        return resolve({
                            blobUrl: reader.result,
                            blob: file
                        });
                    };
                    reader.readAsDataURL(file);
                } else {
                    return resolve({
                        blobUrl: toObjectUrl(file),
                        blob: file
                    });
                }
            });
        }
        function getMimeType(fileExtension) {
            return mimeTypes[fileExtension];
        }
        function checkMimeType(acceptedMimeTypes, mimeType, fileExtension) {
            var regexIsWildCardMimeType = /^\s*(\.\w*$)|(\w*\/\*\w*$)/,
                wildCardMimeType = [],
                isAcceptedMimeType = false;

            _.forEach(acceptedMimeTypes, function (acceptedMimeType) {
                wildCardMimeType = acceptedMimeType.match(regexIsWildCardMimeType);
                if (wildCardMimeType) {

                    if (wildCardMimeType[1]) {
                        isAcceptedMimeType = fileExtension === wildCardMimeType[1].replace(/^\s*\./g, '');
                    } else if (wildCardMimeType[2]) {
                        isAcceptedMimeType = mimeType.indexOf(wildCardMimeType[2].replace('*', '')) > -1;
                    }
                } else {
                    isAcceptedMimeType = mimeType === acceptedMimeType;
                }
                if (isAcceptedMimeType) {
                    return false;
                }
            });

            return isAcceptedMimeType;
        }
        function getFileExtension(filename) {
            if (!filename) {
                return '';
            }

            return (filename.match(/.*\.(\w*)$/) || [])[1];
        }
        function toObjectUrl(file) {
            return $window.URL.createObjectURL(file);
        }
        function convertArrayBufferToJson(arrayBuffer) {
            if (!_.isArrayBuffer(arrayBuffer) || !modernizr.typedarrays || !$window.Uint8Array) {
                return arrayBuffer;
            }

            var encodedString = String.fromCharCode.apply(null, new $window.Uint8Array(arrayBuffer)),
                decodedString,
                result;

            if (encodedString) {
                decodedString = decodeURIComponent(escape(encodedString));
            }

            try {
                result = JSON.parse(decodedString);
            } catch (error) {
                result = arrayBuffer;
            }

            return result;
        }
    }

})();
